import React, { useContext, useState, useEffect } from "react";
import _ from "lodash";
import useMediaQuery from "@mui/material/useMediaQuery";

import { Translate, Localize, translate } from "react-i18nify";
import { QRCode } from "react-qrcode-logo";

import { Button, TextField, InputAdornment, IconButton } from "@mui/material";

import BackspaceIcon from "@mui/icons-material/Backspace";

import { useKioskHorizontalStyles } from "./../../../../kioskstyles";
import SubtitleWrapper from "./../../Components/Shared/PanelElements/SubtitleWrapper";
import CharityElement from "./CharityElement";

import KeypadWidget_B from "./KeypadWidget_B";
import KeyboardAndPinWidget from "./KeyboardAndPinWidget";

import "react-phone-number-input/style.css";

import SocketIOContext from "../../../../contexts/Kiosk/SocketProvider/SocketIOContext";
import KioskContext from "../../../../contexts/Kiosk/KioskContext";

let env = require("./../../../../env");

// props has activeStep
export default function CharityDonationContent({
  isNotMobile = false,
  //changeDrawerMode,
  setSelectedCharity
  //confirmCharity
}) {
  const {} = useContext(KioskContext);

  const { qrCode, getKioskTheme } = useContext(SocketIOContext);

  const [textCharityId, setTextCharityId] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const kiosktheme = getKioskTheme();
  const kioskstyles = useKioskHorizontalStyles();

  // const numberbuttonpress = event => {
  //   setTextCharityId(textCharityId + event.target.innerText);
  // };

  // const backspacepress = event => {
  //   if (textCharityId.length > 0) {
  //     setTextCharityId(textCharityId.substring(0, textCharityId.length - 1));
  //   }
  // };

  // const clearpress = () => {
  //   setTextCharityId("");
  // };

  const updateTextCharityID = newId => {
    setErrorMessage("");
    setTextCharityId(newId);
  };

  const donepress = () => {
    //setErrorMessage("Unable to find charity. Please verify ID.");
    //OR

    const charitiesJSON = getFromSessionStorage("charitiesJSON", null)
      .charities;

    if (charitiesJSON == null) {
      setErrorMessage("No Charities Loaded");
      return;
    }

    console.log("charitiesJSON", charitiesJSON);

    //TODO: Make this go through socket.io
    const foundCharity = charitiesJSON.find(obj => obj.pin === textCharityId);

    if (foundCharity == null) {
      setErrorMessage("No Charities Found");
      return;
    }

    setSelectedCharity({
      imgPath: foundCharity?.logoUrl,
      Title: foundCharity?.name,
      Description: foundCharity?.mission,
      CharityId: foundCharity?.charityID
    });
  };

  return (
    <>
      <div
        class="ks_flexPanelLayoutB_TopContainer"
        style={kioskstyles.flexPanelLayoutB_TopContainer}
      >
        <SubtitleWrapper isNotMobile={isNotMobile}>
          <div style={kioskstyles.charities.charityModalTextColor}>
            <Translate value="application.theme.charitySearchCharity" />
          </div>
        </SubtitleWrapper>
      </div>
      <div
        class="ks_flexPanelLayoutB_MidContainer_M"
        style={{
          ...kioskstyles.flexPanelLayoutB_MidContainer,
          flexDirection: "column"
          //alignContent: "space-between",
          //flexWrap: "wrap"
        }}
      >
        <div
          style={{
            ...kioskstyles.charities.selectInstruction,
            ...kioskstyles.charities.charityModalTextColor
          }}
        >
          <Translate value="application.theme.charitySearchCharityInstruction" />
        </div>
        <div
          style={{
            //height: "inherit"
            //height: "45vh"
            marginTop: "3vh",
            height: "100%"
          }}
        >
          {/* <center>
            <TextField
              id="KioskKey"
              label=""
              type="text"
              value={textCharityId}
              // style={{
              //   marginBottom: "3vh"
              // }}
              sx={{
                marginBottom: "3vh",
                "& .MuiInputBase-root": {
                  height: "7vh", // Change this value
                  width: "38vh",
                  fontSize: "4vh"
                  //textAlign: "center"
                },
                "& .MuiInputBase-input": {
                  textAlign: "center"
                }
              }}
              onChange={event => {
                let newText = event.target.value;
                newText = newText.toUpperCase().trim();
                setTextCharityId(newText);
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => {
                        backspacepress();
                      }}
                      edge="end"
                    >
                      <BackspaceIcon style={{ fontSize: "3.8vh" }} />
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
          </center> */}
          {/* qwewe
          <KeypadWidget_B
            filloutStyle={{ height: "" }}
            buttonRowStyle={{
              marginBottom: "0.4vh",
              display: "flex",
              justifyContent: "center",
              gap: "1vh"
            }}
            errorMessageStyle={{
              color: "red",
              //marginTop: "clamp(0px, 12vw, 24px)",
              fontSize: "clamp(6px, 1.6vw, 26px)",
              //position: "absolute",
              //height: "0px"
              //right: "8vw"
              // width: "100%",
              // maxWidth: "800px",
              // marginRight: "auto"
              width: "100%",
              //height: "clamp(12px, 1.6vw, 26px)"
              height: "clamp(6px, 2vw, 26px)"
            }}
            iconStyle={{ fontSize: "6vh" }}
            errorMessage={errorMessage}
            numberbuttonpress={numberbuttonpress}
            clearbuttonpress={clearpress}
            keypadDone={donepress}
            loading={loading}
          /> */}
          <KeyboardAndPinWidget
            errorMessageStyle={{}}
            errorMessage={""}
            update={updateTextCharityID}
            onEnter={donepress}
          />

          {/* <Button onClick={donepress}>Search</Button> */}
          {errorMessage && (
            <div
              style={{
                marginTop: "1vh",
                fontSize: "2.6vh",
                color: "red",
                width: "100%",
                textAlign: "center"
              }}
            >
              {errorMessage}
            </div>
          )}
        </div>
      </div>
      <div
        style={{
          ...kioskstyles.flexPanelLayoutB_BotContainer,
          //position: "fixed",
          bottom: "10.5vh"
        }}
      >
        <Button
          fullWidth
          variant="contained"
          onClick={donepress}
          sx={{
            ...kioskstyles.charities.charitySearchButton,
            ...kioskstyles.textButtons,
            marginBottom: "0px"
          }}
        >
          <Translate value="application.theme.charityFindById" />
        </Button>
      </div>
    </>
  );
}

function getFromSessionStorage(key, defaultValue = null) {
  try {
    const item = sessionStorage.getItem(key);
    if (item === null) return defaultValue;

    // Try to parse as JSON, fall back to string if it fails
    return JSON.parse(item);
  } catch (error) {
    console.warn(`Error parsing SessionStorage item "${key}":`, error);
    return defaultValue;
  }
}
